











import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { DialogItem } from "../interfaces/Dialog.interfaces";
import IwDialog from "./Dialog.vue";

export default Vue.extend({
    components: {
        IwDialog: IwDialog
    },

    computed: {
        ...mapState("Dialog", ["items"]),
    },

    created: function() {
        window.addEventListener("keyup", this.onkeyUp);
    },

    methods: {
        ...mapActions("Dialog", ["remove"]),

        close: function(item: DialogItem, response: boolean) {
            item.resolve(response);
            this.remove(item);
        },

        onkeyUp: function(e: KeyboardEvent) {

            // `Esc` is for IE11.
            if (!["Escape", "Esc"].includes(e.key)) { return; }

            // Remove last dialog from the stack.
            if (this.items.length > 0) {
                this.close(this.items[this.items.length - 1], false);
            }

            // Clear listener when all dialog boxes are closed.
            if (this.items.length == 0) {
                window.removeEventListener("keyup", this.onkeyUp);
            }
        }
    },
});
